import { DocumentTemplateDto } from 'src/generated-api-client';
import {
    bpmsResourcesManagerApi,
    documentTemplatesSettingsApi,
} from 'src/services/apiServices';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { RequestHelper } from 'src/utils/RequestHelper';

export class SettingsDocumentationTemplatesStoreClass extends BasicStore<
    DocumentTemplateDto,
    any,
    unknown,
    unknown,
    DocumentTemplateDto
> {
    itemDetailsFormKey =
        'embedded:deployment:forms/bo/bo-61-document-templates.json';

    api: BasicStoreApi<
        DocumentTemplateDto,
        unknown,
        unknown,
        DocumentTemplateDto
    > = {
        loadItemForm: (formKey: string, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm({ formKey }, options),
            );
        },
        loadList: async (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            const resp = await RequestHelper.unwrapFromAxiosPromise(
                documentTemplatesSettingsApi.findAllDocumentTemplates(options),
            );

            return resp.content || [];
        },
    };
}

export const SettingsDocumentationTemplatesStore =
    new SettingsDocumentationTemplatesStoreClass();
